'use strict';

angular.module('amexReconciliationApp')
  .component('unmatchedReceiptPoolModal', {
    templateUrl: 'scripts/views/components/unmatched-receipt-pool-modal.html',
    bindings: {
      transactions: '<',
      closeModalCallback: '&'
    },
    controller: function (ReceiptRepository) {
      var self = this;

      self.currentPage = 1;
      self.pageSize = 12;
      self.totalReceipts = 0;
      var receiptsBeingFetched = false;

      trackReceiptsRequest();

      self.closeModal = self.closeModalCallback;

      self.deleteReceipt = trackReceiptsRequest;
      self.pageChanged = trackReceiptsRequest;

      function fetchReceipts() {
        var transactionIds = _.map(self.transactions,'id');
        var pagination = {
          currentPage: self.currentPage - 1,
          size: self.pageSize
        };

        return ReceiptRepository.findUnmatchedReceipts(transactionIds, pagination).then(function (response) {
          self.receipts = response.content;
          self.totalReceipts = response.totalElements;
        });
      }

      function trackReceiptsRequest() {
        receiptsBeingFetched = true;
        return fetchReceipts().finally(function () {
          receiptsBeingFetched = false;
        });
      }

      self.isLoading = function () {
        return receiptsBeingFetched;
      };

      self.hasReceipts = function () {
        return !_.isEmpty(self.receipts);
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/unmatchedReceiptPoolModal.js
// module id = 502
// module chunks = 0